import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  PoModule,
  PoLoadingModule,
  PoTableModule
} from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoTemplatesModule } from '@po-ui/ng-templates';

import { RPAsComponent } from './rpas.component';

@NgModule({
  declarations: [RPAsComponent],
  exports: [RPAsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoLoadingModule,
    PoTemplatesModule,
    PoPageDynamicEditModule,
    PoTableModule
  ]
})
export class RpasModule {}
